import { render, staticRenderFns } from "./priceKeysForm.vue?vue&type=template&id=31abeb44&scoped=true&"
import script from "./priceKeysForm.vue?vue&type=script&lang=js&"
export * from "./priceKeysForm.vue?vue&type=script&lang=js&"
import style0 from "./priceKeysForm.vue?vue&type=style&index=0&id=31abeb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31abeb44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/apps/bowling/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31abeb44')) {
      api.createRecord('31abeb44', component.options)
    } else {
      api.reload('31abeb44', component.options)
    }
    module.hot.accept("./priceKeysForm.vue?vue&type=template&id=31abeb44&scoped=true&", function () {
      api.rerender('31abeb44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/components/priceKeysForm.vue"
export default component.exports